import { Injectable, Inject } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AESEncrypt } from 'src/app/common/Helper/AESEncryp';
import { WebStorageService, LOCAL_STORAGE } from 'ngx-webstorage-service';

@Injectable({
  providedIn: 'root'
})

export class HomeService {
  aes = new AESEncrypt();
  endpoint = environment.apiUrl + 'Administracion/InformacionGeneral/';
  //endpoint = 'https://localhost:55505/' + 'InformacionGeneral/';

  endpointPLD = environment.apiUrl + 'Administracion/PLD/';
  //endpointPLD = 'https://localhost:64026/PLD/';

  constructor(private http: HttpClient,
    @Inject(LOCAL_STORAGE)
    private storage: WebStorageService
  ) {
  }

  //#region "InformacionGeneral"
  estatusClientes(values: any): Observable<any> {
    let result = this.http.post<any>(
			`${this.endpoint}estatusClientes`,
			JSON.stringify(values)
		);
    return result;
  }

  obtieneSucursales(): Observable<any> {
    return this.http.get<any>(
      this.endpoint + 'obtieneSucursales'
    );
  }

  obtieneAlmacenes(values: any): Observable<any> {
    const urlAlmacenes = `${this.endpoint}obtieneAlmacenes?AlmacenId=${values.AlmacenId}`;
    return this.http.get<any>(
      urlAlmacenes
    );
  }

  obtieneEstatusCreditosPolizas(values: any): Observable<any> {
    let result = this.http.post<any>(
			`${this.endpoint}estatusCreditosPolizas`,
			JSON.stringify(values)
		);
    return result;
  }

  obtieneEstatusCuentas(): Observable<any> {
    return this.http.get<any>(
      this.endpoint + 'estatusCuentas'
    );
  }

  obtieneProductos(): Observable<any> {
    return this.http.get<any>(
      this.endpoint + 'obtieneProductos'
    );
  }

  obtieneEntidad(): Observable<any> {
    return this.http.get<any>(
      this.endpoint + 'obtieneEntidades'
    );
  }

  obtieneTipoCambioCincoAtras(): Observable<any> {
    return this.http.get<any>(
      this.endpoint + 'tipoCambioCincoDiasAtras'
    );
  }

  obtieneSujetoObligado(): Observable<any> {
    return this.http.get<any>(
      this.endpoint + 'sujetoObligado'
    );
  }
  //#endregion "InformacionGeneral"

  //#region "PLD"
  contadorAlertas(values: any): Observable<any> {
    let result = this.http.post<any>(
			`${this.endpointPLD}contadorAlertas`,
			JSON.stringify(values)
		);
    return result;
  }

  alertasActivas(values: any): Observable<any> {
    let result =  this.http.post<any>(
      `${this.endpointPLD}alertasActivas`,
			JSON.stringify(values)
    );
    return result;
  }

  riesgoClientes(values: any): Observable<any> {
    let result = this.http.post<any>(
			`${this.endpointPLD}riesgoClientes`,
			JSON.stringify(values)
		);
    return result;
  }

  contadorTransacciones(values: any): Observable<any> {
    // return this.http.get<any>(
    //   this.endpointPLD + 'contadorTransacciones'
    // );
		let result = this.http.post<any>(
			`${this.endpointPLD}contadorTransacciones`,
			JSON.stringify(values)
		);
		return result;

  }

  ultimaActualizacionRiesgo(): Observable<any> {
    return this.http.get<any>(
      this.endpointPLD + 'ultimaActualizacionRiesgo'
    );
  }

  razonSocial(): Observable<any> {
    return this.http.get<any>(
      this.endpoint + 'fichaTecnica'
    )
  }
  //#endregion "PLD"
  buscarAplicacion(): Observable<any> {
		let resultado = this.http.get(`${this.endpoint}getAppData`);
		return resultado;
	}

  uploadLicense(formData: FormData) {
    return this.http.post<any>(
      `${this.endpoint}UploadLicense`,
      formData
    );
  }
 
	getEnvironment() : any | null {
    try{
      const encrypted = this.storage.get('environment');

      if(!encrypted){
        return null;
      }

      return this.aes.decryptModel(encrypted);
    }catch(error){
      return null;
    }
	}

  removeEnvironment(){
    this.storage.remove('environment');
  }

}

